import { DatePicker, Icon, Input, Label, Modal } from '@components';
import { formatISODate } from '@utils/date';

import theme from '../../../../../../themes/colors';

interface GroupStartDateSelectionProps {
  formData: any;
  setIsStartDateModalOpen: (value: boolean) => void;
  isStartDateModalOpen: boolean;
  onStartDateChange: (date: string) => void;
  isStartDateDisabled: boolean;
  groupStartDateClassName?: string;
  startDateAlertClassName?: string;
}

const GroupStartDateSelection = ({
  formData,
  isStartDateModalOpen,
  onStartDateChange,
  setIsStartDateModalOpen,
  isStartDateDisabled,
  groupStartDateClassName,
  startDateAlertClassName
}: GroupStartDateSelectionProps) => (
  <>
    <div className={`w-full md:w-1/2 lg:w-1/3 ${groupStartDateClassName}`}>
      <Label
        label="Group Activation Date"
        className="!mb-2 !text-content"
        isRequired
      />
      <Input
        readOnly
        leftIconName="calendar"
        value={
          formData.startDate ? formatISODate({ date: formData.startDate }) : ''
        }
        onClick={() => {
          setIsStartDateModalOpen(true);
        }}
        placeholder="Select payment start day"
        className={`${isStartDateDisabled ? 'text-grey' : ''}`}
        disabled={isStartDateDisabled}
        inputStyle="!bg-theme"
      />
      <div
        className={`my-1 flex gap-1 text-sm text-cofeeGreyBlue6 ${startDateAlertClassName}`}
      >
        <Icon
          name="alert-circle"
          stroke={theme.subText}
          size="16"
          className="mt-0.25"
        />
        Fee collection will begin from the start date.
      </div>
    </div>
    {isStartDateModalOpen && (
      <Modal
        isOpen={isStartDateModalOpen}
        onCancel={() => setIsStartDateModalOpen(false)}
      >
        <DatePicker
          confirmButtonLabel="Apply"
          confirmButtonStyle="text-primary"
          handleConfirm={onStartDateChange}
          cancelButtonLabel="Cancel"
          handleCancel={() => {
            setIsStartDateModalOpen(false);
          }}
          isMaxDateRequired={!!formData?.endDate}
          maxDate={new Date(formData?.endDate)}
          selectedDate={
            (formData?.startDate && new Date(formData?.startDate)) || new Date()
          }
          calendarStyle="!bg-bgBase"
          title="Select Start Date"
        />
      </Modal>
    )}
  </>
);

export default GroupStartDateSelection;
